import React from 'react';
import { array, bool, number, shape, string } from 'prop-types';

import { COURSE_GROUP_TEMPLATE } from 'constants/routingPath';
import CourseList from 'routes/course/components/CourseList';
import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';
import useStyles from 'hooks/useStyles';
import Link from 'components/Link';
import { ChevronIcon } from 'components/Icon';

import styles from './CourseListByGroup.scss';

const TWO_COLUMN = 8;
const ONE_COLUMN = 4;

const getCurrentCourseList = courseList => {
  return courseList.length === TWO_COLUMN
    ? courseList
    : courseList.filter((item, index) => index < ONE_COLUMN);
};

function CourseListByGroup({
  groupId,
  groupTitle,
  courseInfo,
  courseCardMoreText,
}) {
  useStyles(styles);

  const { list, hasMore } = courseInfo;
  const getOfficialSiteURL = useGetOfficialSiteURL();
  const currentCourseList = getCurrentCourseList(list);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h4>{groupTitle}</h4>
        <div className={styles.headerLeft}>
          <Link
            show={hasMore}
            className={styles.moreButton}
            to={getOfficialSiteURL(COURSE_GROUP_TEMPLATE, { id: groupId })}
          >
            <div>{courseCardMoreText}</div>
            <ChevronIcon className={styles.moreButtonIcon} />
          </Link>
        </div>
      </div>
      <CourseList
        groupId={groupId}
        groupTitle={groupTitle}
        courseList={currentCourseList}
      />
    </div>
  );
}

CourseListByGroup.defaultProps = {
  courseInfo: { list: [], hasMore: false },
};

CourseListByGroup.propTypes = {
  groupId: number.isRequired,
  groupTitle: string.isRequired,
  courseCardMoreText: string.isRequired,
  courseInfo: shape({
    list: array,
    hasMore: bool,
  }),
};

export default CourseListByGroup;
